export interface ContentTaskTagCombinationTagGq {
  tagId?: number;
  tagGroupId: number;
}

export const ContentTaskTagCombinationTagGqProps = `
    tagId
    tagGroupId
`;
